import { type FC } from 'react';

import { Typography } from '@craft/ui/components/typography';

interface LtiErrorDetailProps {
  readonly errorDetail: string;
}

export const LtiErrorDetail: FC<LtiErrorDetailProps> = ({ errorDetail }) => (
  <Typography color='text.secondary' variant='body2'>
    <pre>{errorDetail}</pre>
  </Typography>
);
